import textInput from "./TextInput";
import dropdownInput from "./DropdownInput";
import dropdownInputUF from "./DropdownInputUF";
import fileInput from "./FileInput";
import datePicker from "./DatePicker";
import iconCheckBox from "./IconCheckBox";
import switchInput from "./SwitchInput";
import tags from "./Tags";
import colorPicker from "./ColorPicker";
import editor from "./Editor";
import multiSelectInput from "./MultiSelectInput";
import otpInput from "./OtpInput";
import checkbox from "./Checkbox";
import textAreaInput from "./TextAreaInput";
import textInputNoti from "./TextInputNoti";


export const TextInput = textInput;
export const DropdownInput = dropdownInput;
export const DropdownInputUF = dropdownInputUF;
export const FileInput = fileInput;
export const DatePicker = datePicker;
export const IconCheckBox = iconCheckBox;
export const SwitchInput = switchInput;
export const Tags = tags;
export const ColorPicker = colorPicker;
export const Editor = editor;
export const MultiSelectInput = multiSelectInput;
export const OtpInput = otpInput;
export const Checkbox = checkbox;
export const TextAreaInput = textAreaInput;
export const TextInputNoti = textInputNoti;

